import { useMemo } from 'react';
import getCaptchaActionEnabled from '../functions/getCaptchaActionEnabled.client';

/**
 * Returns whether or not captcha is enabled for the given action.
 */
const useCaptchaActionEnabled = (action: string) => useMemo(() => getCaptchaActionEnabled(action), [action]);

export default useCaptchaActionEnabled;
